import '../../styles/components/admin.css'
import { requireAuth, getAllProducts, createProduct, updateProduct, uploadProductImage, deleteProductImage, getCategories, getAccessToken } from '../../lib/supabase.js'

export function renderProductForm(outlet, params) {
  const editId = params?.id || null
  const isEdit = Boolean(editId)

  requireAuth(async () => {
    outlet.innerHTML = `
      <div class="admin-page">
        <div class="container admin-form-page">
          <a href="#/admin" class="admin-back">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" width="16" height="16">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5"/>
            </svg>
            Back to Products
          </a>

          <div class="admin-topbar" style="margin-bottom: var(--space-6);">
            <h1 class="admin-title">${isEdit ? 'Edit Product' : 'New Product'}</h1>
          </div>

          <div id="admin-form-error" class="admin-error" style="display:none; margin-bottom: var(--space-5);"></div>
          <div id="admin-form-loading" style="text-align:center; padding: var(--space-10); color: var(--color-text-secondary);">
            ${isEdit ? 'Loading product…' : ''}
          </div>

          <form id="admin-product-form" class="admin-form" style="display:none;" novalidate>

            <div class="admin-form-row">
              <div class="form-group">
                <label class="form-label" for="pf-name">Name <span style="color:var(--color-error)">*</span></label>
                <input id="pf-name" class="form-input" type="text" placeholder="Carbon Series 7&quot; Disc" required />
              </div>
              <div class="form-group">
                <label class="form-label" for="pf-sku">SKU</label>
                <input id="pf-sku" class="form-input" type="text" placeholder="APL-GD-7-C" />
              </div>
            </div>

            <div class="form-group">
              <label class="form-label" for="pf-slug">URL Slug</label>
              <input id="pf-slug" class="form-input" type="text" placeholder="carbon-fiber-flat-platen-2x42" />
              <span style="font-size: var(--text-xs); color: var(--color-text-muted);">SEO URL: /products/your-slug — auto-generated from name if left empty</span>
            </div>

            <div class="form-group">
              <label class="form-label" for="pf-description">Description</label>
              <textarea id="pf-description" class="form-input form-textarea" rows="4" placeholder="Product description…"></textarea>
            </div>

            <div class="admin-form-row" style="grid-template-columns: 1fr 1fr 1fr">
              <div class="form-group">
                <label class="form-label" for="pf-price">Price (USD) <span style="color:var(--color-error)">*</span></label>
                <input id="pf-price" class="form-input" type="number" min="0.01" step="0.01" placeholder="49.99" required />
              </div>
              <div class="form-group">
                <label class="form-label" for="pf-stock">Stock Qty <span style="color:var(--color-error)">*</span></label>
                <input id="pf-stock" class="form-input" type="number" min="0" step="1" placeholder="100" required />
              </div>
              <div class="form-group">
                <label class="form-label" for="pf-weight">Weight (lbs)</label>
                <input id="pf-weight" class="form-input" type="number" min="0" step="0.01" placeholder="1.0" />
              </div>
            </div>

            <div class="admin-form-row">
              <div class="form-group">
                <label class="form-label" for="pf-category">Category</label>
                <div style="display:flex; gap: var(--space-2);">
                  <select id="pf-category" class="form-input" style="flex:1;"></select>
                  <input id="pf-category-custom" class="form-input" type="text" placeholder="New category…" style="flex:1; display:none;" />
                </div>
                <button type="button" id="pf-category-toggle" class="admin-back" style="margin: var(--space-2) 0 0; font-size: var(--text-xs);">+ Add new category</button>
              </div>
              <div class="form-group" style="display:flex; flex-direction:column; gap: var(--space-3); justify-content:flex-end; padding-bottom: var(--space-2);">
                <label style="display:flex; align-items:center; gap: var(--space-3); cursor:pointer;">
                  <input id="pf-active" type="checkbox" style="width:16px; height:16px; accent-color: var(--color-accent);" />
                  <span class="form-label" style="margin:0;">Active (visible in shop)</span>
                </label>
                <label style="display:flex; align-items:center; gap: var(--space-3); cursor:pointer;">
                  <input id="pf-purchasable" type="checkbox" style="width:16px; height:16px; accent-color: var(--color-accent);" />
                  <span class="form-label" style="margin:0;">Purchasable (show Add to Cart)</span>
                </label>
              </div>
            </div>

            <!-- Button override (shown when not purchasable) -->
            <div id="pf-button-override" class="admin-form-row" style="display:none;">
              <div class="form-group">
                <label class="form-label" for="pf-button-text">Button Text</label>
                <input id="pf-button-text" class="form-input" type="text" placeholder="Get in touch" />
                <span style="font-size: var(--text-xs); color: var(--color-text-muted);">Defaults to "Get in touch" if left empty</span>
              </div>
              <div class="form-group">
                <label class="form-label" for="pf-button-url">Button URL</label>
                <input id="pf-button-url" class="form-input" type="text" placeholder="#/contact" />
                <span style="font-size: var(--text-xs); color: var(--color-text-muted);">Use #/contact for contact page, or paste a full external URL</span>
              </div>
            </div>

            <!-- Specifications / Metadata -->
            <div class="form-group">
              <label class="form-label">Specifications</label>
              <div id="pf-meta-list" style="display:flex; flex-direction:column; gap: var(--space-2); margin-bottom: var(--space-2);"></div>
              <button type="button" id="pf-meta-add" class="admin-back" style="font-size: var(--text-xs);">+ Add specification</button>
            </div>

            <!-- Images -->
            <div class="form-group">
              <label class="form-label">Images</label>
              <div id="pf-image-list" class="admin-image-list"></div>
              <label class="admin-upload-btn" id="pf-upload-label">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.75" width="18" height="18">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"/>
                </svg>
                <span id="pf-upload-label-text">Upload image</span>
                <input id="pf-image-input" type="file" accept="image/*" multiple style="display:none;" />
              </label>
            </div>

            <div class="admin-form-actions">
              <button type="submit" class="btn btn-primary" id="pf-submit-btn">
                ${isEdit ? 'Save Changes' : 'Create Product'}
              </button>
              <a href="#/admin" class="btn">Cancel</a>
            </div>
          </form>
        </div>
      </div>
    `

    // Track current images (URLs)
    let currentImages = []

    // Load categories into select
    const categorySelect = document.getElementById('pf-category')
    const categoriesRaw = await getCategories()
    // getCategories returns objects {id, name, ...} from the table, or strings as fallback
    const allCats = categoriesRaw.map(c => (typeof c === 'string' ? c : c.name))
    allCats.forEach(c => {
      const opt = document.createElement('option')
      opt.value = c
      opt.textContent = c
      categorySelect.appendChild(opt)
    })

    // Category toggle: switch between select and custom text input
    const categoryCustom = document.getElementById('pf-category-custom')
    const categoryToggle = document.getElementById('pf-category-toggle')
    let useCustomCategory = false
    categoryToggle.addEventListener('click', () => {
      useCustomCategory = !useCustomCategory
      categorySelect.style.display = useCustomCategory ? 'none' : 'block'
      categoryCustom.style.display = useCustomCategory ? 'block' : 'none'
      categoryToggle.textContent = useCustomCategory ? '← Use existing category' : '+ Add new category'
      if (useCustomCategory) categoryCustom.focus()
    })

    // Toggle button override fields based on purchasable checkbox
    const purchasableCheckbox = document.getElementById('pf-purchasable')
    const buttonOverride = document.getElementById('pf-button-override')
    const toggleButtonFields = () => {
      buttonOverride.style.display = purchasableCheckbox.checked ? 'none' : 'grid'
    }
    purchasableCheckbox.addEventListener('change', toggleButtonFields)

    // Load product if editing
    let existingProduct = null
    if (isEdit) {
      try {
        const all = await getAllProducts()
        existingProduct = all.find(p => p.id === editId)
        if (!existingProduct) {
          showError('Product not found.')
          return
        }
        currentImages = Array.isArray(existingProduct.images) ? [...existingProduct.images] : []
        fillForm(existingProduct, allCats)
      } catch (err) {
        showError('Failed to load product: ' + (err.message || 'Unknown error'))
        return
      }
    } else {
      document.getElementById('pf-active').checked = true
      document.getElementById('pf-purchasable').checked = true
    }

    renderImageList(currentImages)

    // Metadata editor
    const existingMeta = existingProduct?.metadata || {}
    Object.entries(existingMeta).forEach(([k, v]) => addMetaRow(k, String(v)))
    document.getElementById('pf-meta-add').addEventListener('click', () => addMetaRow('', ''))

    // Auto-generate slug from name (only for new products or if slug is empty)
    const nameInput = document.getElementById('pf-name')
    const slugEl = document.getElementById('pf-slug')
    nameInput.addEventListener('input', () => {
      if (!slugEl.dataset.manual) {
        slugEl.value = nameInput.value.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-{2,}/g, '-').replace(/^-+|-+$/g, '')
      }
    })
    slugEl.addEventListener('input', () => { slugEl.dataset.manual = '1' })
    if (isEdit && slugEl.value) slugEl.dataset.manual = '1'

    document.getElementById('admin-form-loading').style.display = 'none'
    document.getElementById('admin-product-form').style.display = 'flex'

    // Image upload
    document.getElementById('pf-image-input').addEventListener('change', async (e) => {
      const files = [...e.target.files]
      if (!files.length) return
      const label = document.getElementById('pf-upload-label-text')
      label.textContent = `Uploading ${files.length} image${files.length > 1 ? 's' : ''}…`
      document.getElementById('pf-upload-label').style.opacity = '0.6'
      document.getElementById('pf-upload-label').style.pointerEvents = 'none'
      try {
        const urls = await Promise.all(files.map(f => uploadProductImage(f)))
        currentImages = [...currentImages, ...urls]
        renderImageList(currentImages)
      } catch (err) {
        showError('Image upload failed: ' + (err.message || 'Unknown error'))
      } finally {
        label.textContent = 'Upload image'
        document.getElementById('pf-upload-label').style.opacity = ''
        document.getElementById('pf-upload-label').style.pointerEvents = ''
        e.target.value = ''
      }
    })

    // Image remove (delegated)
    document.getElementById('pf-image-list').addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-remove-img]')
      if (!btn) return
      const url = btn.dataset.removeImg
      currentImages = currentImages.filter(u => u !== url)
      renderImageList(currentImages)
      // Delete from storage (best effort)
      deleteProductImage(url).catch(() => {})
    })

    // Form submit
    document.getElementById('admin-product-form').addEventListener('submit', async (e) => {
      e.preventDefault()
      hideError()

      const name = document.getElementById('pf-name').value.trim()
      const slugInput = document.getElementById('pf-slug').value.trim()
      const slug = slugInput || name.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-{2,}/g, '-').replace(/^-+|-+$/g, '')
      const sku = document.getElementById('pf-sku').value.trim()
      const description = document.getElementById('pf-description').value.trim()
      const priceRaw = parseFloat(document.getElementById('pf-price').value)
      const stockRaw = parseInt(document.getElementById('pf-stock').value, 10)
      const weightRaw = parseFloat(document.getElementById('pf-weight').value)
      const category = useCustomCategory
        ? categoryCustom.value.trim()
        : categorySelect.value
      const active = document.getElementById('pf-active').checked
      const purchasable = document.getElementById('pf-purchasable').checked
      const button_text = document.getElementById('pf-button-text').value.trim() || null
      const button_url = document.getElementById('pf-button-url').value.trim() || null

      if (!name) return showError('Name is required.')
      if (isNaN(priceRaw) || priceRaw <= 0) return showError('Enter a valid price.')
      if (isNaN(stockRaw) || stockRaw < 0) return showError('Enter a valid stock quantity.')
      if (!category) return showError('Category is required.')

      const payload = {
        name,
        slug,
        sku: sku || null,
        description: description || null,
        price_cents: Math.round(priceRaw * 100),
        stock_qty: stockRaw,
        weight_lbs: isNaN(weightRaw) || weightRaw < 0 ? null : weightRaw,
        category,
        active,
        purchasable,
        button_text: purchasable ? null : button_text,
        button_url: purchasable ? null : button_url,
        images: currentImages,
        metadata: getMetadata(),
      }

      const btn = document.getElementById('pf-submit-btn')
      btn.disabled = true
      btn.textContent = isEdit ? 'Saving…' : 'Creating…'

      try {
        let savedId = editId
        if (isEdit) {
          await updateProduct(editId, payload)
        } else {
          const created = await createProduct(payload)
          savedId = created?.id
        }

        // Best-effort Stripe sync (do not block save).
        if (savedId) {
          const stripeAction = active ? 'upsert' : 'archive'
          const result = await syncToStripe(savedId, stripeAction)
          if (result?.error) {
            showError(`Saved, but Stripe sync failed: ${result.error}. Retry from the product list.`)
            btn.disabled = false
            btn.textContent = isEdit ? 'Save Changes' : 'Create Product'
            return
          }
        }

        window.location.hash = '#/admin'
      } catch (err) {
        showError(err.message || 'Failed to save product.')
        btn.disabled = false
        btn.textContent = isEdit ? 'Save Changes' : 'Create Product'
      }
    })
  })
}

function renderImageList(images) {
  const list = document.getElementById('pf-image-list')
  if (!list) return
  if (!images.length) {
    list.innerHTML = ''
    return
  }
  list.innerHTML = images.map(url => `
    <div class="admin-image-thumb">
      <img src="${url}" alt="" />
      <button type="button" class="admin-image-remove" data-remove-img="${url}" title="Remove image">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" width="14" height="14">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
  `).join('')
}

function fillForm(p, allCats) {
  document.getElementById('pf-name').value = p.name || ''
  document.getElementById('pf-sku').value = p.sku || ''
  document.getElementById('pf-slug').value = p.slug || ''
  document.getElementById('pf-description').value = p.description || ''
  document.getElementById('pf-price').value = p.price_cents ? (p.price_cents / 100).toFixed(2) : ''
  document.getElementById('pf-stock').value = p.stock_qty ?? ''
  document.getElementById('pf-weight').value = p.weight_lbs != null ? p.weight_lbs : ''

  const categorySelect = document.getElementById('pf-category')
  const cat = p.category || 'uncategorized'
  if (!allCats.includes(cat)) {
    const opt = document.createElement('option')
    opt.value = cat
    opt.textContent = cat
    categorySelect.appendChild(opt)
  }
  categorySelect.value = cat
  document.getElementById('pf-active').checked = Boolean(p.active)
  document.getElementById('pf-purchasable').checked = p.purchasable !== false
  document.getElementById('pf-button-text').value = p.button_text || ''
  document.getElementById('pf-button-url').value = p.button_url || ''

  // Show button override fields if not purchasable
  const buttonOverride = document.getElementById('pf-button-override')
  if (buttonOverride) buttonOverride.style.display = p.purchasable === false ? 'grid' : 'none'
}

function addMetaRow(key = '', value = '') {
  const list = document.getElementById('pf-meta-list')
  if (!list) return
  const row = document.createElement('div')
  row.style.cssText = 'display:flex; gap: var(--space-2); align-items:center;'
  row.innerHTML = `
    <input class="form-input pf-meta-key" type="text" placeholder="Label (e.g. Radius)" value="${escapeAttr(key)}"
      style="flex:1; padding: var(--space-1) var(--space-3); height:36px;" />
    <input class="form-input pf-meta-val" type="text" placeholder="Value (e.g. 36 inches)" value="${escapeAttr(value)}"
      style="flex:2; padding: var(--space-1) var(--space-3); height:36px;" />
    <button type="button" class="pf-meta-remove" title="Remove"
      style="flex-shrink:0; background:none; border:none; cursor:pointer; color:var(--color-error); padding: var(--space-1);">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" width="16" height="16">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  `
  row.querySelector('.pf-meta-remove').addEventListener('click', () => row.remove())
  if (!key) row.querySelector('.pf-meta-key').focus()
  list.appendChild(row)
}

function getMetadata() {
  const rows = document.querySelectorAll('#pf-meta-list > div')
  const meta = {}
  rows.forEach(row => {
    const key = row.querySelector('.pf-meta-key')?.value.trim()
    const val = row.querySelector('.pf-meta-val')?.value.trim()
    if (key) meta[key] = val
  })
  return meta
}

function escapeAttr(str) {
  return String(str || '').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
}

function showError(msg) {
  const el = document.getElementById('admin-form-error')
  if (!el) return
  el.textContent = msg
  el.style.display = 'block'
  el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

function hideError() {
  const el = document.getElementById('admin-form-error')
  if (el) el.style.display = 'none'
}

async function syncToStripe(productId, action) {
  try {
    const token = await getAccessToken()
    if (!token) {
      console.warn('[product-form] No access token — skipping Stripe sync')
      return { skipped: true }
    }
    const res = await fetch('/api/admin/sync-stripe-product', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ action, productId }),
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) {
      throw new Error(data?.error || `Sync failed (${res.status})`)
    }
    return data
  } catch (err) {
    console.error('[product-form] Stripe sync error:', err)
    return { error: err.message }
  }
}
